(function (window, document, $) {

    $(document).ready(function () {
        // Submenu mobile ==============================================================================================
        $('#menu-hoofd-menu .menu-item-has-children > a').on('click', function(e){
            // toggle dropdown only if the nav menu item was clicked
            if(e.target != this) return;

            e.preventDefault();
            $(this).parents('.menu-item-has-children').toggleClass('open');
        });

        $(document).on('click', function(e) {
            // get the clicked element
            var $clicked = $(e.target);
            // if the clicked element is not a descendent of the dropdown
            if ($clicked.closest('.menu-item-has-children').length === 0) {
                // close the dropdown
                $('.menu-item-has-children').removeClass('open');
            }
        });

        // Hamburger restyling ===========================================================================================
        
        function toggleMobileMenu(e) {
            e.preventDefault();
            $('.header__navigation__mobile__overlay').toggleClass('show__overlay');
            $('.header__navigation__mobile__sidebar').toggleClass('show__sidebar');
        }

        $('body').on('click', '.navigation__mobile__link, .header__navigation__mobile__close__link, .show__overlay', toggleMobileMenu);
    });

}(window, document, jQuery));
